import { Notyf } from 'notyf'
import { MAX_FILE_SIZE_MB } from '/@src/constants/index'

const notyf = new Notyf({
  duration: 3000,
})

export function checkFiles(file: File[]) {
  const fileListArr = [...file]
  Array.prototype.forEach.call(fileListArr, (currentFile, index) => {
    if (parseFloat((currentFile.size / 1000000).toFixed(2)) > MAX_FILE_SIZE_MB) {
      notyf.error(`Súbor ${currentFile.name} presahuje ${MAX_FILE_SIZE_MB}MB`)
      fileListArr.splice(index, 1)
    }
  })
  return fileListArr
}

export function checkFileSizeAndTypes(file: File, size: number, types: string[]) {
  if (size) {
    if (file?.size / 1048576 > size || !types?.includes(file.type)) {
      notyf.error(`Chybná veľkosť alebo typ súboru ${file.name}`)
      return null
    }
  } else if (!types?.includes(file.type)) {
    notyf.error(`Chybny typ súboru ${file.name}`)
    return null
  }
  return file
}
